<template>
  <crud-base
    :url="url"
    :columns="columns"
    :onDelete="() => {}"
    :onUpdate="() => {}"
    :onStore="() => {}"
    :enableSearch="true"
    :checkAlerts="true"
    :formInputs="formInputs"
    primaryKey="id"
  />
</template>

<script>
import CrudBase from '../../../components/crud/CrudBase';
import { yesNoRepresentation } from '@/helpers/transformers';

export default {
  name: 'grupos-cobranca',
  components: { CrudBase },
  data() {
    return {
      url: '/admin/condicoes/cobranca-grupo',
      columns: [
        { label: 'ID', field: 'id', sortable: false },
        {
          label: 'Cobrança',
          field: 'cobranca',
          sortable: false,
          representedAs: (row) =>
            row?.cobranca
              ? `${row.cobranca_id} - ${row.cobranca.descricao}`
              : row.cobranca_id,
        },
        { label: 'Grupo', field: 'grupo_id', sortable: false },
        {
          label: 'Ativo',
          field: 'ativo',
          sortable: false,
          representedAs: (row) => yesNoRepresentation(row.ativo),
        },
      ],
      formInputs: {
        id: {
          type: 'string',
          ui: {
            label: 'Identificador',
            columns: 4,
            widget: 'AutoIdWidget',
            widgetConfig: { campo1Key: 'cobranca_id', campo2Key: 'grupo_id' },
          },
          rules: { required: { value: true, errMsg: 'Preencha o Identificador.' } },
        },
        cobranca_id: {
          type: 'number',
          ui: {
            label: 'Cobrança',
            columns: 4,
            widget: 'SearchSelectWidget',
            widgetConfig: {
              searchUrl: '/admin/condicoes/cobrancas',
              idField: 'id',
              labelField: 'descricao',
              preload: false,
            },
          },
          rules: { required: { value: true, errMsg: 'Campo obrigatório.' } },
        },
        grupo_id: {
          type: 'string',
          ui: { label: 'Grupo', columns: 4 },
          rules: { required: { value: true, errMsg: 'Campo obrigatório.' } },
        },
        ativo: {
          type: 'number',
          default: 1,
          ui: {
            label: 'Ativo',
            columns: 4,
            widget: 'select',
            widgetConfig: {
              placeholder: 'Selecione',
              enumSource: [{ label: 'Sim', value: 1 }, { label: 'Não', value: 0 }],
            },
          },
        },
        acessob2b: {
          type: 'number',
          default: 1,
          ui: {
            label: 'Visível B2B?',
            columns: 4,
            widget: 'select',
            widgetConfig: {
              placeholder: 'Selecione',
              enumSource: [{ label: 'Sim', value: 1 }, { label: 'Não', value: 0 }],
            },
          },
        },
        acessocallcenter: {
          type: 'number',
          default: 1,
          ui: {
            label: 'Visível Call?',
            columns: 4,
            widget: 'select',
            widgetConfig: {
              placeholder: 'Selecione',
              enumSource: [{ label: 'Sim', value: 1 }, { label: 'Não', value: 0 }],
            },
          },
        },
        acessofv: {
          type: 'number',
          default: 1,
          ui: {
            label: 'Visível FV?',
            columns: 4,
            widget: 'select',
            widgetConfig: {
              placeholder: 'Selecione',
              enumSource: [{ label: 'Sim', value: 1 }, { label: 'Não', value: 0 }],
            },
          },
        },
      },
    };
  },
};
</script>
